module.exports = __webpack_public_path__ + "static/media/20ECE22.4fa2e617.jpg";